<template>
  <div class="item">
    <div class="field-narrow">{{ index + 1 }}</div>
    <div class="field-medium">{{ item.name }}</div>
    <div class="field-medium">{{ item.format_name }}</div>
    <div class="field-medium">{{ item.topic }}</div>
    <div class="field-medium" v-if="item.unit">{{ item.unit }}</div>
    <div class="field-medium" v-else>{{ t('none') }}</div>
    <div class="field-medium">{{ convertGMT0toGMT8(item.updatetime) }}</div>
    <div class="field-medium">{{ convertGMT0toGMT8(item.createtime) }}</div>
    <div class="field-medium" v-if="item.id > 0">
      <button type="button" @click="viewItem" class="btn">{{ $t('information') }}</button>
      <button type="button" @click="editItem" class="btn">
        {{ $t('edit') }}</button>
      <button type="button" @click="deleteItem" class="btn">
        {{ $t('delete') }}</button>
    </div>
    <div class="field-medium" v-else />
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { inject } from 'vue';
import { deleteData } from '../utils/api';
import { convertGMT0toGMT8 } from '../utils/stringValid';

export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n();
    const apiBaseUrl = inject('apiBaseUrl');
    const url = 'data';
    return { t, apiBaseUrl, url };
  },
  methods: {
    convertGMT0toGMT8,
    viewItem() {
      this.$router.push(`/${this.url}/${this.item.id}`);
    },
    editItem() {
      this.$router.push(`/${this.url}/edit/${this.item.id}`);
    },
    async deleteItem() {
      try {
        const data = await deleteData(
          this.t,
          `${this.apiBaseUrl}/delete/${this.url}`,
          this.item.id,
        );
        if (data) {
          this.$emit('remove-item', this.item);
        }
      } catch (error) {
        console.error('Error during deletion:', error);
      }
    },
  },
};
</script>

<style>
.item {
  display: flex;
  justify-content: space-between;
  font-weight: normal;
  padding: 10px;
}

.field-narrow {
  flex: 1;
  text-align: center;
}

.field-medium {
  flex: 2;
  text-align: center;
}
.field-medium-path {
  flex: 2;
  text-align: left;
}
</style>
